import { render, staticRenderFns } from "./GeneralSettingsOrder.vue?vue&type=template&id=aac3ea38&"
import script from "./GeneralSettingsOrder.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingsOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports